import { Icons, getIcon } from "@/components/Icons";
import { bottomBarSlots, type Area } from "./model";

export function BottomBar({ areas, activeId, onPick, onMore }: {
  areas: Area[];
  activeId: string | null;
  onPick: (area: Area) => void;
  onMore: () => void;
}) {
  const { primary, more } = bottomBarSlots(areas);
  const moreActive = more.some((a) => a.id === activeId);
  return (
    <nav className="bottom-bar" aria-label="Areas">
      {primary.map((a) => {
        const I = getIcon(a.icon);
        return (
          <button key={a.id} type="button" aria-current={a.id === activeId ? "true" : undefined} onClick={() => onPick(a)}>
            <I size={20} /><span>{a.label}</span>
          </button>
        );
      })}
      {more.length > 0 && (
        <button type="button" aria-current={moreActive ? "true" : undefined} onClick={onMore}>
          <Icons.More size={20} /><span>More</span>
        </button>
      )}
    </nav>
  );
}
